module.exports = __webpack_public_path__ + "static/hack-oregon-logo-33e5ccce7300dbc23de7ab7fa794d706.png";